import Chart from '../../mixins/base-chart'
import { Pie } from 'vue-chartjs'

Vue.component('pie-chart', {
	mixins: [Chart, Pie]
})
